import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {RecordsTable} from '../tables/RecordsTable';
import {SubscriptionStatusBanner} from '../../../components/SubscriptionStatusBanner';

export const IndexPage = () => {
    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <>
                <SubscriptionStatusBanner/>
                <SimplePageContentWrapper>
                    <RecordsTable/>
                </SimplePageContentWrapper>
            </>
        </SimplePageLayout>
    );
};
